import React, { useEffect, useState } from "react";
import AdminSidebar from "../../components/AdminSidebar";
import "./admin.css";

export default function AdminAllTowerAdmins() {
  const [admins, setAdmins] = useState([]);
  const [error, setError] = useState("");

  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${API}/api/admin/tower-admin/all`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        if (!res.ok) {
          setError("Failed to load tower admins");
          return;
        }
        setAdmins(await res.json());
      } catch (err) {
        setError("Server error while loading tower admins");
      }
    };
    load();
  }, [API]);

  return (
    <div className="admin-layout">
      <AdminSidebar />

      <div className="admin-content">
        <h1>All Tower Admins</h1>

        {error && <p className="admin-error">{error}</p>}

        <div className="admin-table">
          <div className="admin-header">
            <span>Name</span>
            <span>Email</span>
            <span>Tower</span>
            <span>Status</span>
          </div>

          {admins.map((a) => (
            <div className="admin-row" key={a.id}>
              <span>{a.name}</span>
              <span>{a.email}</span>
              <span>{a.tower}</span>
              <span className={`status-badge status-${a.status}`}>{a.status}</span>
            </div>
          ))}

          {admins.length === 0 && !error && (
            <p className="admin-empty">No tower admins registered yet</p>
          )}
        </div>
      </div>
    </div>
  );
}